export type HorseReceiptMark = {
    mark: number;
    horse: string;
    isForeignOwned: boolean;
    nationality?: string;
    isCorrect: boolean;
    isScratched: boolean;
    isReserve: boolean;
};

export type HorseReceiptLeg = {
    legNumber: number;
    hasOutcome: boolean;
    outcomes: number[];
    isSneaked: boolean;
    isCanceled: boolean;
    marks: Array<HorseReceiptMark>;
};

export type HorseReceiptLegStatus = "DECIDED" | "CANCELED";

export type HorseReceiptLegSummary = {
    outcome: number[];
    reserveOrder: number[];
    scratched: number[];
    status: HorseReceiptLegStatus;
};

export type HorseReceiptEffectiveMarks = {
    [leg: number]: number[];
};

export type HorseReceiptSneakState = {
    [leg: number]: boolean;
};

export type HorseReceiptCouponSelections = {
    legs: {
        [leg: string]: {
            marks: number[];
            reserves: number[];
        };
    };
};

export enum HorseReceiptPushEvent {
    ADD = "ADD",
    UPDATE = "UPDATE",
}

export type HorseReceiptMeta = {
    id: string;
    numberOfSystems: number;
};
